module.exports = __webpack_public_path__ + "static/moodboard-preview-11431451e8f080db05d35f1f9ad0e2ce.png";